import { GridRowsProp } from "@mui/x-data-grid";
import { motion } from "motion/react";
import { useCallback, useMemo } from "react";

import StatusFilterItem from "@/components/table/StatusFilterItem";
import { driverStatusFilters } from "@/constants/DriverStatusFilters";
import { CommonFilterSwitch } from "@/pages/Plannn/types";

import { useDriverStatusContext } from "../../DriverStatusContext";

export function DriverStatusFilter({ allRows }: { allRows: GridRowsProp }) {
    const { filters, handleFilters } = useDriverStatusContext();
    const activeStyle = useMemo(() => {
        for (const [index, item] of driverStatusFilters.entries()) {
            if (item.value === filters.working) return { translateX: `${index * 100}%`, backgroundColor: item.hover };
        }
        return false;
    }, [filters]);
    const vals = useMemo(
        () =>
            allRows.reduce(
                (prev, curr) => {
                    const value = driverStatusFilters.find((item) => {
                        return (
                            (curr.includesActiveStatus && item.value === CommonFilterSwitch.TRUE) ||
                            (!curr.includesActiveStatus && CommonFilterSwitch.FALSE === item.value)
                        );
                    })?.value;
                    if (value) prev[value] += 1;
                    return prev;
                },
                {
                    [CommonFilterSwitch.ALL]: 0,
                    [CommonFilterSwitch.FALSE]: 0,
                    [CommonFilterSwitch.TRUE]: 0,
                }
            ),
        [allRows]
    );

    const handleUpdate = useCallback(
        (status: CommonFilterSwitch) => {
            handleFilters({ working: filters.working === status ? CommonFilterSwitch.ALL : status });
        },
        [filters]
    );
    const filterElements = useMemo(
        () =>
            driverStatusFilters.map((item) => (
                <StatusFilterItem
                    key={item.tooltip.title}
                    {...item}
                    active={filters.working === item.value}
                    count={vals[item.value]}
                    handleUpdate={handleUpdate}
                />
            )),
        [filters, vals]
    );
    return (
        <div className=" relative py-1 grid grid-cols-2 bg-gray-100/80  divide-x divide-gray-300    rounded">
            {filterElements}
            {activeStyle && (
                <motion.div
                    layoutId="hotel-status-filter"
                    id="hotel-status-filter"
                    animate={activeStyle}
                    transition={{ type: "tween" }}
                    className="  rounded-none absolute   !self-center  !h-[calc(100%-8px)]     !w-1/2 "
                ></motion.div>
            )}
        </div>
    );
}
